module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-wax-museum®-in-los-angeles-california-82d687e442ce2524af762db009268e46.png";